const PC_SOURCE_LINK_MAP = {
  'steam top sellers':
    '/intelligence/storeRanks/PCGlobal/more/steam?source=steam%2520top%2520sellers',
  'daily steam top 100 sellers':
    '/intelligence/storeRanks/PCGlobal/more/steam?source=steam%2520top%2520sellers',
  'steam most played':
    '/intelligence/storeRanks/PCGlobal/more/steam?source=steam%2520most%2520played',
  'daily steam top 100 players':
    '/intelligence/storeRanks/PCGlobal/more/steam?source=steam%2520most%2520played',
  'steam new and trending':
    '/intelligence/storeRanks/PCGlobal/more/steam?source=steam%2520new%2520and%2520trending',
  'steam top wish lists':
    '/intelligence/storeRanks/PCGlobal/more/steam?source=steam%2520top%2520wish%2520lists',

  'epic top sellers': '/intelligence/storeRanks/PCGlobal/more/epic?source=epic%2520top%2520sellers',
  'epic top popular': '/intelligence/storeRanks/PCGlobal/more/epic?source=epic%2520top%2520popular',
};

const CONSOLE_SOURCE_LINK_MAP = {
  'playstation best selling':
    '/intelligence/storeRanks/ConsoleRegion/more/playstation?source=playstation%2520best%2520selling',
  'playstation most downloaded':
    '/intelligence/storeRanks/ConsoleRegion/more/playstation?source=playstation%2520most%2520downloaded',
  'playstation new games':
    '/intelligence/storeRanks/ConsoleRegion/more/playstation?source=playstation%2520new%2520games',
  'playstation coming soon':
    '/intelligence/storeRanks/ConsoleRegion/more/playstation?source=playstation%2520coming%2520soon',
  'playstation indies games':
    '/intelligence/storeRanks/ConsoleRegion/more/playstation?source=playstation%2520indies%2520games',
  'playstation free to play':
    '/intelligence/storeRanks/ConsoleRegion/more/playstation?source=playstation%2520free%2520to%2520play',

  'xbox new release':
    '/intelligence/storeRanks/ConsoleRegion/more/xbox?source=xbox%2520new%2520release',
  'xbox upcoming': '/intelligence/storeRanks/ConsoleRegion/more/xbox?source=xbox%2520upcoming',
  'xbox most played':
    '/intelligence/storeRanks/ConsoleRegion/more/xbox?source=xbox%2520most%2520played',
  'xbox best rated':
    '/intelligence/storeRanks/ConsoleRegion/more/xbox?source=xbox%2520best%2520rated',
  'xbox top free': '/intelligence/storeRanks/ConsoleRegion/more/xbox?source=xbox%2520top%2520free',
  'xbox top paid': '/intelligence/storeRanks/ConsoleRegion/more/xbox?source=xbox%2520top%2520paid',

  'nintendo best sellers':
    '/intelligence/storeRanks/ConsoleRegion/more/nintendo?source=nintendo%2520best%2520sellers',
  'nintendo new release':
    '/intelligence/storeRanks/ConsoleRegion/more/nintendo?source=nintendo%2520new%2520release',
  'nintendo coming soon':
    '/intelligence/storeRanks/ConsoleRegion/more/nintendo?source=nintendo%2520coming%2520soon',
};

export const storeRankJumpLinkConfig = {
  pc: PC_SOURCE_LINK_MAP,
  console: CONSOLE_SOURCE_LINK_MAP,
  combine: { ...PC_SOURCE_LINK_MAP, ...CONSOLE_SOURCE_LINK_MAP },
};
